<div class="maintenance-cont">
  <div *ngIf="isMobileDevice" class="cont-back-button">
    <span class="back-button">
      <app-ds-button-icon
        [icon]="iconChevronRight"
        [isLoading]="loaderByClose"
        [buttonSize]="buttonIconSize"
        [iconSize]="16"
        (clickEvent)="goBack()">
      </app-ds-button-icon>
    </span>
  </div>
  <div class="body-cont">
    <div class="img-cont">
      <div class="img" [ngStyle]="{'background-image': ' url(' + (IMAGE | baseImage: IMAGES_BASE_PATH)  + ')'}" ></div>
    </div>
    <div class="text-cont">
      <h3 class="principal-text">
        {{ 'MAINTENANCE_PAGE.PRINCIPAL_TEXT' | transloco }}
      </h3>
      <p class="sub-text">
        {{ 'MAINTENANCE_PAGE.SUB_TEXT' | transloco }}
      </p>
    </div>
  </div>
</div>